module.exports = {"jugar":"Play","instrucciones":"Instructions"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/locals/home/fr.json
// module id = 174
// module chunks = 11